import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createContact } from "api";
import { toastEmitter } from "components/Toast";

export default function useCreateContact({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: createContact,
    mutationKey: ["createContact"],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter("error", responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(["contactLists"]);
      toastEmitter("success", responseData?.data?.message);
    },
  });
  return { ...Request };
}
